'use client';

import { useSyncExternalStore } from 'react';

export const RenderMode = {
  client: 'client',
  server: 'server',
} as const;

const subscribe = () => {};

export function useRenderMode() {
  return useSyncExternalStore(
    () => subscribe,
    () => RenderMode.client,
    () => RenderMode.server
  );
}
